import { render, staticRenderFns } from "./inspiration-not-finish.vue?vue&type=template&id=16cc41d2&scoped=true&"
import script from "./inspiration-not-finish.vue?vue&type=script&lang=js&"
export * from "./inspiration-not-finish.vue?vue&type=script&lang=js&"
import style0 from "./inspiration-not-finish.vue?vue&type=style&index=0&id=16cc41d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc41d2",
  null
  
)

export default component.exports